import { render, staticRenderFns } from "./BaseContractsIcon.vue?vue&type=template&id=0e248db2"
import script from "./BaseContractsIcon.vue?vue&type=script&lang=js"
export * from "./BaseContractsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports